import styled from "@emotion/styled";
import { GridListItem } from "react-aria-components";

export const StyledGridListItem = styled(GridListItem)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.md};
  min-height: 60px;
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
  border: 1px solid ${({ theme }) => theme.colors.grey.x50};

  outline: none;

  ${({ onAction, theme }) =>
    !!onAction &&
    `
    user-select: none;
    cursor: pointer;

    &[data-focused] {
      background-color: ${theme.colors.grey.x50};
    }

    &[data-selected] {
      background-color: ${theme.colors.mblue.x50};
    }

    &:hover:not([data-disabled]) {
      background-color: ${theme.colors.grey.x50};
    }
  `}

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  justify-content: center;
`;

export const StyledLeftAddon = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledRightAddon = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;
